import React, { useEffect, useState } from 'react';
import { Col, Row, Table, Modal, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import FirstLevelInspPreviewForShiftingPreview from './FirstLevelInspPreviewForShiftingPreview';
import { FaEye } from 'react-icons/fa';
import { viewImage } from '../../CommonUtils/viewImage';
import { config } from '../../CommonUtils/CommonURLS';
import { CommonAxiosGet } from '../../CommonUtils/CommonAxios';

export default function PreviewsForPhaseTwo() {
  const navigate = useNavigate();
  const login = sessionStorage.getItem("user_id");
  const collegeName = sessionStorage.getItem("user_name");
  const CllgCodeFromSession = login?.split("_")[1] || "";

  // Modal state
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalContent, setModalContent] = useState(null);

  // Open modal with dynamic title and content
  const openModal = (title, content) => {
    setModalTitle(title);
    setModalContent(content);
    setShowModal(true);
  };

  // ========== PREVIEW CONTENT COMPONENTS ==========
  // Replace these with your actual preview JSX or import your real components

  const InspectionPreview1Content = () => (
    <div>
      <h5>First Level Inspection Preview (Phase 2)</h5>
      <hr />
      <p><strong>College Name:</strong> {collegeName}</p>
      <p><strong>College Code:</strong> {CllgCodeFromSession}</p>
      <p><strong>Inspection Type:</strong> Shifting Scrutiny – Phase 2</p>
      {/* Add your actual inspection preview form, table, or data here */}
      <div className="mt-3">
        <h6>Infrastructure Status</h6>
        <p>Building: Approved</p>
        <p>Land: Owned</p>
        <p>Library: Adequate</p>
      </div>
    </div>
  );

  const InspectionPreview2Content = () => (
    <div>
      <h5>Second Level Inspection Preview</h5>
      <hr />
      <p><strong>College Name:</strong> {collegeName}</p>
      <p><strong>College Code:</strong> {CllgCodeFromSession}</p>
      <p><strong>Additional Details:</strong> This preview is only shown for the first inspection row.</p>
      {/* Your second preview content */}
      <div className="mt-3">
        <h6>Deficiency Status</h6>
        <p>Deficiencies identified: 2</p>
        <p>Remarks: Pending compliance</p>
      </div>
    </div>
  );

  const [jicpdf, setJicpdf] = useState([]);

  function GetJICpdf(CllgCodeFromSession) {
    const url = `${config.url.FAC_URL}getShiftingOfInstDetails/${CllgCodeFromSession}`;
    CommonAxiosGet(url)
      .then((res) => {
        if (res?.data?.status === true) {
          setJicpdf(res?.data?.data || []);
          console.log("res?.data?.data", res?.data?.data)
        } else {
          setJicpdf([]);
        }
      })
      .catch(() => {
        setJicpdf([]);
      });
  }

  useEffect(() => {
    if (CllgCodeFromSession) {
      GetJICpdf(CllgCodeFromSession);
    }
  }, [CllgCodeFromSession]);

  return (
    <>
      <h5 className='text-success'>Inspection Preview</h5>
      <Row>
        <Col>
          <Table bordered responsive>
            <thead className="table-primary text-center">
              <tr>
                <th style={{ width: "5%" }}>S.No</th>
                <th style={{ width: "45%" }}>College Name</th>
                <th style={{ width: "20%" }}>College Code</th>
                <th style={{ width: "30%" }}>College Preview</th>
                <th style={{ width: "30%" }}> Inspection Preview </th>
                <th style={{ width: "30%" }}> JIC Committe Pdf</th>

                {/* jic_pdf */}

              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={{ width: "5%" }}>1</td>
                <td style={{ width: "45%" }}>{collegeName}</td>
                <td style={{ width: "20%" }}>{CllgCodeFromSession}</td>
                <td style={{ width: "20%", textAlign: "center" }}>
                  <button
                    onClick={() => navigate("/CollegeDetails", { state: { clgcode: CllgCodeFromSession } })}
                    style={{ padding: "5px 10px", backgroundColor: "#007bff", color: "#fff", border: "none", borderRadius: "4px", textAlign: "center" }}
                  >
                    <FaEye />
                  </button>
                </td>
                <td style={{ width: "20%", textAlign: "center" }}>
                  <button
                    onClick={() => openModal("Inspection Preview ", <FirstLevelInspPreviewForShiftingPreview collCode={CllgCodeFromSession} nocType={"shifting"} name="phase1" />)}
                    style={{ padding: "5px 10px", backgroundColor: "green", color: "#fff", border: "none", borderRadius: "4px" }}
                  >
                    <FaEye />
                  </button>
                </td>
                <td>
                  <button type="button" className="btn btn-primary" onClick={() => viewImage(jicpdf[0]?.jic_pdf)}>
                    <FaEye size={18} />
                  </button></td>
                {/* <td style={{ width: "30%" }}>
                  <button
                    onClick={() => openModal("Inspection Preview 2", <FirstLevelInspPreviewForShiftingPreview collCode={CllgCodeFromSession} nocType={"shifting"}  name="phase2"/>)}
                    style={{ padding: "5px 10px", backgroundColor: "#ffc107", color: "#212529", border: "none", borderRadius: "4px" }}
                  >
                    View Inspection Preview 2
                  </button>
                </td> */}
              </tr>
            </tbody>
          </Table>
        </Col>
      </Row>

      {/* Bootstrap Modal */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg" centered>
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalContent}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}